import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=35b441c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b441c6"]])

export default __exports__